import React, { useEffect, useRef } from 'react'
import './Project_15.css'
import data_head from '../../Images/data_head.png';
import paiplot from '../../Images/paiplot.png';
import corrplot from '../../Images/corr.png';
import corr_1 from '../../Images/corr_1.png';
import comp from '../../Images/comp.png';
//import video1 from "../../Images/proj_4.mp4";
import { Link, useLocation } from 'react-router-dom';
//import patentimg from '../../Images/ama_scre.png';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
//import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';
//import jsx from 'react-syntax-highlighter/dist/esm/languages/prism/jsx';

import Plot from 'react-plotly.js';
import { darken } from '@mui/material';

const { tableau } = window;

function Project_15() {
    const codestring = `
   import pandas as pd
   import numpy as np
   import plotly.graph_objects as go
   import matplotlib.pyplot as plt
   import seaborn as sns
   from plotly.subplots import make_subplots
 `;

    const data = [
        {
            x: ['Survived', 'Deceased'],
            y: [203, 96],
            type: 'bar',
            marker: {
                color: ['#ADD8E6', '#FA8072'],
            },
        },
    ];

    const layout = {
        xaxis: {
            title: 'Death Event',
            tickvals: [0, 1],
            ticktext: ['Survived', 'Deceased'],
        },

        yaxis: {
            title: 'Count',
        },
    };






    const ref = useRef(null);
    const url = "https://public.tableau.com/views/HealthCare_Heart_Failure/Dashboard1?:language=en-US&:display_count=n&:origin=viz_share_link";

    const initViz = () => {
        if (!ref.current.innerHTML) {
            new tableau.Viz(ref.current, url);
        }
    };

    useEffect(initViz, []);


    return (
        <div>
            <div className='outer_class'>

                <div className="text_box">

                    <div className='class_1'>
                        <h1>
                            Viraj Vhatkar
                        </h1>
                    </div>

                    <div className="inner_1_1">

                        <div className="inner_1_2">


                            <div className="_a_3">

                                <Link to="/projects" className='project-tag'>Strategy</Link>
                            </div>

                            <div className="_a_3">

                                <Link to="/projects" className='project-tag'>UIUX</Link>
                            </div>

                            <div class="_a_3">

                                <Link to="/projects" className='project-tag'>Ideation</Link>

                            </div>

                            <div class="_a_3">

                                <Link to="https://public.tableau.com/views/HealthCare_Heart_Failure/Dashboard1?:language=en-US&:display_count=n&:origin=viz_share_link" className='project-tag'>Tableau</Link>

                            </div>
                        </div>



                    </div>

                    <div className='project_name'>
                        <h2>
                            Heart_Failure_Analytics
                        </h2>
                    </div>


                </div>

                {/* <img src={projectimag} alt='image1' className='paten_image_1' /> */}
                <div className='project_content_101'>
                    <h2>
                        Utilizing Machine_learning and Statistical techniques for the prediction of heart failure.                </h2>
                    <div ref={ref} className='tab_101' ></div>


                    <div className='details'>
                        This project was made possible thanks to the research paper titled   <a href="https://rdcu.be/dm82Y">"Machine learning can predict survival of patients with heart failure from serum creatinine and ejection fraction alone"</a>

                        <br>
                        </br><br>
                        </br>
                        Machine learning algorithms play a pivotal and precise role in forecasting heart disease, a condition that remains one of the gravest threats to human health worldwide.
                        The fusion of machine learning with Big Data tools, facilitated by rapid technological advancements, equips us to manage vast volumes of unstructured and exponentially expanding data.
                        Heart disease, characterized by the heart's inability to supply sufficient blood to vital organs for normal functioning, demands a proactive approach to mitigate its impact.
                        <br>
                        </br><br>
                        </br>
                        In our era of heightened technology adoption and data acquisition, the realm of heart disease prediction has been revolutionized by machine learning algorithms. Now, let's delve deeper into the domain of heart disease prediction using Python and harness the potential of these advancements.
                        <br>
                        </br>
                        <h3>
                            Heart Disease Prediction Using Machine Learning and Statistical techniques
                        </h3>
                        <br>
                        </br>
                        In this Chapter, I would create visualizations to illustrate the variable distributions within the Heart
                        Failure Prediction dataset and investigate their associations with the target variable, <strong>"DEATH_EVENT"</strong>. Building upon the insights gained from this exploration,
                        I develop two distinct machine learning models for the purpose of evaluating their effectiveness in predicting the target variable.
                        These models leverage the most strongly correlated subset of variables from the dataset.
                        <br>
                        </br><br>
                        </br>
                        Importing Important libraries:
                        <SyntaxHighlighter language="jsx" style={prism}  className="custom-syntax-highlighter_table">
                            {codestring}
                        </SyntaxHighlighter>
                        <br></br>
                        Now let’s import the data and move further:
                        <br>
                        </br>

                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {` data=pd.read_csv("heart.csv")
 ht=data
 data.head() `}
                        </SyntaxHighlighter>

                        {/* <img src={projectimag} alt='image1' className='paten_image_1' /> */}
                        <img src={data_head} alt='image1' className='data_hd' />
                        <br>
                        </br>
                        Treating missing values is essential in data analysis and modeling to ensure data quality, model performance, and the validity of conclusions drawn from the data.
                        <br>
                        </br>Failing to address missing values can lead to biased and inaccurate results, while treating them appropriately can enhance the overall quality and utility of your data-driven insights.
                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">

                            {`data.shape //Check the shape of the DataFrame (number of rows and columns)
data.columns //Get the list of column names in the DataFrame
data.isna().sum()  //Check for missing values (count of missing values in each column) `}

                        </SyntaxHighlighter>
                        <h4>
                            Exploratory Data Analysis
                        </h4>
                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                            {`data.describe()`}
                        </SyntaxHighlighter>

                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table" >

                            {`| Statistic                | age    | anaemia | creatinine_phosphokinase | diabetes | ejection_fraction | high_blood_pressure | platelets   | serum_creatinine | serum_sodium | sex   | smoking | time   | DEATH_EVENT |
|---------------------------|--------|---------|--------------------------|----------|-------------------|---------------------|-------------|------------------|--------------|-------|---------|--------|-------------|
| count                     | 299.00 | 299.00  | 299.00                   | 299.00   | 299.00            | 299.00              | 299.00      | 299.00           | 299.00       | 299.00| 299.00  | 299.00 | 299.00      |
| mean                      | 60.83  | 0.43    | 581.84                   | 0.42     | 38.08             | 0.35                | 263358.03   | 1.39             | 136.63       | 0.65  | 0.32    | 130.26 | 0.32        |
| std                       | 11.89  | 0.50    | 970.29                   | 0.49     | 11.83             | 0.48                | 97804.24    | 1.03             | 4.41         | 0.48  | 0.47    | 77.61  | 0.47        |
| min                       | 40.00  | 0.00    | 23.00                    | 0.00     | 14.00             | 0.00                | 25100.00    | 0.50             | 113.00       | 0.00  | 0.00    | 4.00   | 0.00        |
| 25%                       | 51.00  | 0.00    | 116.50                   | 0.00     | 30.00             | 0.00                | 212500.00   | 0.90             | 134.00       | 0.00  | 0.00    | 73.00  | 0.00        |
| 50%                       | 60.00  | 0.00    | 250.00                   | 0.00     | 38.00             | 0.00                | 262000.00   | 1.10             | 137.00       | 1.00  | 0.00    | 115.00 | 0.00        |
| 75%                       | 70.00  | 1.00    | 582.00                   | 1.00     | 45.00             | 1.00                | 303500.00   | 1.40             | 140.00       | 1.00  | 1.00    | 203.00 | 1.00        |
| max                       | 95.00  | 1.00    | 7861.00                  | 1.00     | 80.00             | 1.00                | 850000.00   | 9.40             | 148.00       | 1.00  | 1.00    | 285.00 | 1.00        | `}

                        </SyntaxHighlighter>


                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                            {`data.info()`}
                        </SyntaxHighlighter>



                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table" style={{ fontSize: '12px' }}>
                            {`class 'pandas.core.frame.DataFrame'
RangeIndex: 299 entries, 0 to 298
Data columns (total 13 columns):
 #   Column                    Non-Null Count  Dtype  
---  ------                    --------------  -----  
 0   age                       299 non-null    float64
 1   anaemia                   299 non-null    int64  
 2   creatinine_phosphokinase  299 non-null    int64  
 3   diabetes                  299 non-null    int64  
 4   ejection_fraction         299 non-null    int64  
 5   high_blood_pressure       299 non-null    int64  
 6   platelets                 299 non-null    float64
 7   serum_creatinine          299 non-null    float64
 8   serum_sodium              299 non-null    int64  
 9   sex                       299 non-null    int64  
 10  smoking                   299 non-null    int64  
 11  time                      299 non-null    int64  
 12  DEATH_EVENT               299 non-null    int64  
dtypes: float64(3), int64(10)
memory usage: 30.5 KB`}
                        </SyntaxHighlighter>

                        The data set has no null

                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`import plotly.express as px
dt=data['DEATH_EVENT'].value_counts()
dt
colors = [ '#ADD8E6','#FA8072']
fig = px.bar(dt)
fig.update_xaxes(tickvals=[0, 1], ticktext=['Survived', 'Deceased'])
fig.update_traces(marker_color=colors)`}
                        </SyntaxHighlighter><br>
                        </br>
                        <Plot data={data}
                            layout={layout} /><br>
                        </br><br>
                        </br><br>
                        </br>
                        In our dataset, there are 203 instances of individuals who survived and 96 instances of individuals who deceased.<br>
                        </br> This substantial difference in counts between the two groups highlights the imbalanced nature of our dataset.
                        <h3>
                            Statistical quantitative description of the category features
                        </h3>
                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                            {`categorical_data = data[["anaemia","diabetes","high_blood_pressure","sex","smoking"]]
categorical_data`}
                        </SyntaxHighlighter>

                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_big">
                            {`df = pd.DataFrame(data)

    # Calculate percentages
    total_patients = len(df)
    anemia_true = df[df['anaemia'] == 1]
    anemia_false = df[df['anaemia'] == 0]

    anemia_death_true = df[(df['anaemia'] == 1) & (df['DEATH_EVENT'] == 1)]
    anemia_death_false = df[(df['anaemia'] == 0) & (df['DEATH_EVENT'] == 1)]

    anemia_survive_true = df[(df['anaemia'] == 1) & (df['DEATH_EVENT'] == 0)]
    anemia_survive_false = df[(df['anaemia'] == 0) & (df['DEATH_EVENT'] == 0)]
    ###################################################################################
    percentage_anemia_true = (len(anemia_true) / total_patients) * 100
    percentage_anemia_false = (len(anemia_false) / total_patients) * 100

    percentage_anemia_death_true = (len(anemia_death_true) /len (anemia_death_true + anemia_death_false)) * 100
    percentage_anemia_death_false = (len(anemia_death_false) /len (anemia_death_true + anemia_death_false)) * 100


    percentage_anemia_survive_true = (len(anemia_survive_true) /len (anemia_survive_true+anemia_survive_false)) * 100
    percentage_anemia_survive_false = (len(anemia_survive_false) /len (anemia_survive_true+anemia_survive_false)) * 100
    ######################################################################################
    ######################################################################################
    high_bp_true = df[df['high_blood_pressure'] == 1]
    high_bp_false = df[df['high_blood_pressure'] == 0]

    high_bp_death_true = df[(df['high_blood_pressure'] == 1) & (df['DEATH_EVENT'] == 1)]
    high_bp_death_false = df[(df['high_blood_pressure'] == 0) & (df['DEATH_EVENT'] == 1)]

    high_bp_survive_true = df[(df['high_blood_pressure'] == 1) & (df['DEATH_EVENT'] == 0)]
    high_bp_survive_false = df[(df['high_blood_pressure'] == 0) & (df['DEATH_EVENT'] == 0)]
    ###################################################################################
    percentage_high_bp_true = (len(high_bp_true) / total_patients) * 100
    percentage_high_bp_false = (len(high_bp_false) / total_patients) * 100

    percentage_high_bp_death_true = (len(high_bp_death_true) / (len(high_bp_death_true) + len(high_bp_death_false))) * 100
    percentage_high_bp_death_false = (len(high_bp_death_false) / (len(high_bp_death_true) + len(high_bp_death_false))) * 100

    percentage_high_bp_survive_true = (len(high_bp_survive_true) / (len(high_bp_survive_true) + len(high_bp_survive_false))) * 100
    percentage_high_bp_survive_false = (len(high_bp_survive_false) / (len(high_bp_survive_true) + len(high_bp_survive_false))) * 100
    ######################################################################################
    ######################################################################################
    diabetes_true = df[df['diabetes'] == 1]
    diabetes_false = df[df['diabetes'] == 0]

    diabetes_death_true = df[(df['diabetes'] == 1) & (df['DEATH_EVENT'] == 1)]
    diabetes_death_false = df[(df['diabetes'] == 0) & (df['DEATH_EVENT'] == 1)]

    diabetes_survive_true = df[(df['diabetes'] == 1) & (df['DEATH_EVENT'] == 0)]
    diabetes_survive_false = df[(df['diabetes'] == 0) & (df['DEATH_EVENT'] == 0)]
    ###################################################################################
    percentage_diabetes_true = (len(diabetes_true) / total_patients) * 100
    percentage_diabetes_false = (len(diabetes_false) / total_patients) * 100

    percentage_diabetes_death_true = (len(diabetes_death_true) / (len(diabetes_death_true) + len(diabetes_death_false))) * 100
    percentage_diabetes_death_false = (len(diabetes_death_false) / (len(diabetes_death_true) + len(diabetes_death_false))) * 100

    percentage_diabetes_survive_true = (len(diabetes_survive_true) / (len(diabetes_survive_true) + len(diabetes_survive_false))) * 100
    percentage_diabetes_survive_false = (len(diabetes_survive_false) / (len(diabetes_survive_true) + len(diabetes_survive_false))) * 100

    ######################################################################################
    ######################################################################################
    sex_true = df[df['sex'] == 1]
    sex_false = df[df['sex'] == 0]

    sex_death_true = df[(df['sex'] == 1) & (df['DEATH_EVENT'] == 1)]
    sex_death_false = df[(df['sex'] == 0) & (df['DEATH_EVENT'] == 1)]

    sex_survive_true = df[(df['sex'] == 1) & (df['DEATH_EVENT'] == 0)]
    sex_survive_false = df[(df['sex'] == 0) & (df['DEATH_EVENT'] == 0)]
    ###################################################################################
    percentage_sex_true = (len(sex_true) / total_patients) * 100
    percentage_sex_false = (len(sex_false) / total_patients) * 100

    percentage_sex_death_true = (len(sex_death_true) / (len(sex_death_true) + len(sex_death_false))) * 100
    percentage_sex_death_false = (len(sex_death_false) / (len(sex_death_true) + len(sex_death_false))) * 100

    percentage_sex_survive_true = (len(sex_survive_true) / (len(sex_survive_true) + len(sex_survive_false))) * 100
    percentage_sex_survive_false = (len(sex_survive_false) / (len(sex_survive_true) + len(sex_survive_false))) * 100
    ######################################################################################
    ######################################################################################
    smoking_true = df[df['smoking'] == 1]
    smoking_false = df[df['smoking'] == 0]

    smoking_death_true = df[(df['smoking'] == 1) & (df['DEATH_EVENT'] == 1)]
    smoking_death_false = df[(df['smoking'] == 0) & (df['DEATH_EVENT'] == 1)]

    smoking_survive_true = df[(df['smoking'] == 1) & (df['DEATH_EVENT'] == 0)]
    smoking_survive_false = df[(df['smoking'] == 0) & (df['DEATH_EVENT'] == 0)]
    #####################################################################################
    percentage_smoking_true = (len(smoking_true) / total_patients) * 100
    percentage_smoking_false = (len(smoking_false) / total_patients) * 100

    percentage_smoking_death_true = (len(smoking_death_true) / (len(smoking_death_true) + len(smoking_death_false))) * 100
    percentage_smoking_death_false = (len(smoking_death_false) / (len(smoking_death_true) + len(smoking_death_false))) * 100

    percentage_smoking_survive_true = (len(smoking_survive_true) / (len(smoking_survive_true) + len(smoking_survive_false))) * 100
    percentage_smoking_survive_false = (len(smoking_survive_false) / (len(smoking_survive_true) + len(smoking_survive_false))) * 100`}
                        </SyntaxHighlighter>


                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_big">
                            {`// Create dictionaries to store the data for each group
anemia_data = {
    "Anemsia(1:True)": {
        "Sample #": len(anemia_true),
        "Sample %": percentage_anemia_true,
        "Dead patients #": len(anemia_death_true) ,
        "Dead patients %": percentage_anemia_death_true,
        "Survived patients #": len(anemia_survive_true),
        "Survived patients %": percentage_anemia_survive_true,
    },
    "Anemsia(0:fasle)": {
        "Sample #": len(anemia_false),
        "Sample %": percentage_anemia_false,
        "Dead patients #": len(anemia_death_false),
        "Dead patients %": percentage_anemia_death_false,
        "Survived patients #": len(anemia_survive_false),
        "Survived patients %": percentage_anemia_survive_false,
    },
}

high_bp_data = {
        "High BP (1: True)": {
        "Sample #": len(high_bp_true),
        "Sample %": percentage_high_bp_true,
        "Dead patients #": len(high_bp_death_true),
        "Dead patients %": percentage_high_bp_death_true ,
        "Survived patients #": len(high_bp_survive_true),
        "Survived patients %": percentage_high_bp_survive_true,
    },
    
    "High BP (0: false)": {
        "Sample #": len(high_bp_false),
        "Sample %": percentage_high_bp_false,
        "Dead patients #": len(high_bp_death_false),
        "Dead patients %": percentage_high_bp_death_false ,
        "Survived patients #": len(high_bp_survive_false),
        "Survived patients %": percentage_high_bp_survive_false,
    },
}

diabetes_data = {
    "Diabetes(1:True)": {
        "Sample #": len(diabetes_true),
        "Sample %": percentage_diabetes_true,
        "Dead patients #": len(diabetes_death_true),
        "Dead patients %": percentage_diabetes_death_true,
        "Survived patients #": len(diabetes_survive_true),
        "Survived patients %": percentage_diabetes_survive_true,
    },
    "Diabetes(0:false)": {
        "Sample #": len(diabetes_false),
        "Sample %": percentage_diabetes_false,
        "Dead patients #": len(diabetes_death_false),
        "Dead patients %": percentage_diabetes_death_false ,
        "Survived patients #": len(diabetes_survive_false),
        "Survived patients %": percentage_diabetes_survive_false,
    },
}

sex_data = {
    "Sex(1:True)": {
        "Sample #": len(sex_true),
        "Sample %": percentage_sex_true,
        "Dead patients #": len(sex_death_true),
        "Dead patients %": percentage_sex_death_true,
        "Survived patients #": len(sex_survive_true),
        "Survived patients %": percentage_sex_survive_true,
    },
    "Sex(0:false)": {
        "Sample #": len(sex_false),
        "Sample %": percentage_sex_false,
        "Dead patients #": len(sex_death_false) ,
        "Dead patients %": percentage_sex_death_false,
        "Survived patients #": len(sex_survive_false),
        "Survived patients %": percentage_sex_survive_false,
    },
}


smoking_data = {
    "Smoking(1:True)": {
        "Sample #": len(smoking_true),
        "Sample %": percentage_smoking_true,
        "Dead patients #": len(smoking_death_true) ,
        "Dead patients %": percentage_smoking_death_true,
        "Survived patients #": len(smoking_survive_true),
        "Survived patients %": percentage_smoking_survive_true,
    },
    "Smoking(0:false)": {
        "Sample #": len(smoking_false),
        "Sample %": percentage_smoking_false,
        "Dead patients #": len(smoking_death_false),
        "Dead patients %": percentage_smoking_death_false,
        "Survived patients #": len(smoking_survive_false),
        "Survived patients %": percentage_smoking_survive_false,
    },
}

//Print the data in the specified format with lines between alternate groups
print("{:<25} {:<10} {:<10} {:<15} {:<15} {:<20} {:<20}".format(
    "Category feature", "Sample_#", "Sample_%", "Dead_patients_#", "Dead_patients_%", "Survived_patients_#", 
    "Survived_patients_%"))
print("-" * 105) 
for data_group in [anemia_data, high_bp_data, diabetes_data,smoking_data ,sex_data]:
    for condition, data in data_group.items():
        print("{:<25} {:<10} {:<10.2f} {:<15} {:<15.2f} {:<20} {:<20.2f}".format(
            condition, data["Sample #"], data["Sample %"], data["Dead patients #"], data["Dead patients %"],
            data["Survived patients #"], data["Survived patients %"]))
    print("-" * 105)  # Add a line of dashes between groups`}
                        </SyntaxHighlighter>

                        The Output: Statistical Feature of each category
                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table" style={{ fontSize: '12px' }}>
                            {`Category feature      Sample_#   Sample_%   Dead_patients_#    Dead_patients_%    Survived_patients_#    Survived_patients_% 
------------------------------------------------------------------------------------------------------------------------------
Anemsia(1:True)           129        43.14         46               47.92                 83                   40.89               
Anemsia(0:fasle)          170        56.86         50               52.08                120                   59.11               
------------------------------------------------------------------------------------------------------------------------------
High BP (1: True)         105        35.12         39               40.62                 66                   32.51               
High BP (0: false)        194        64.88         57               59.38                137                   67.49               
------------------------------------------------------------------------------------------------------------------------------
Diabetes(1:True)          125        41.81         40               41.67                 85                   41.87               
Diabetes(0:false)         174        58.19         56               58.33                118                   58.13               
------------------------------------------------------------------------------------------------------------------------------
Smoking(1:True)           96         32.11         30               31.25                 66                   32.51               
Smoking(0:false)          203        67.89         66               68.75                137                   67.49               
------------------------------------------------------------------------------------------------------------------------------
Sex(1:True)               194        64.88         62               64.58                132                   65.02               
Sex(0:false)              105        35.12         34               35.42                 71                   34.98               
------------------------------------------------------------------------------------------------------------------------------
`}
                        </SyntaxHighlighter>

                        <h3>
                            Data visualization
                        </h3>


                        Lets see How is our Data Distributed:
                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter">
                            {`sns.pairplot(df,hue='DEATH_EVENT')`}
                        </SyntaxHighlighter>
                        {/* <img src={projectimag} alt='image1' className='paten_image_1' /> */}
                        <img src={paiplot} alt='image1' className='paiplot_image' />
                        <br>
                        </br>


                        I suggest utilizing <strong>Bar plots</strong> using subplots in Matplotlib or Seaborn to enhance data visualization clarity. In my initial approach, I categorized the variables into two groups: categorical and continuous.
                        <br></br>   <br></br>  This categorization enabled me to create two distinct graphical representations that offer a comprehensive view of the data. These visualizations not only showcase the <strong>data distribution </strong>  but also highlight any <strong>skewness</strong>  present and provide insights into <strong>
                            potential outliers
                        </strong>
                        <br></br>     This approach ensures a more detailed and informative exploration of the dataset.
                        <br>
                        </br>
                        <br></br> <br></br> <br></br>
                        Let's examine a correlation map to gain insights into how variables interact with each other and understand the relationships within the dataset.
                        <br></br>   Correlation maps are valuable because they reveal the degree and direction of associations between variables, providing important information about how one variable may influence or relate to another.
                        <br>
                        </br>
                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`corrmat = df.corr()
top_corr_features = corrmat.index
plt.figure(figsize=(16,16))
//plot heat map
g=sns.heatmap(df[top_corr_features].corr(),annot=True,cmap="RdYlGn")
plt.show()`}


                        </SyntaxHighlighter><img src={corrplot} alt='image1' className='corrplot_image' />


                        <br>
                        </br>
                        <br></br>
                        Lets Calculate the correlation between the  selective variable and the DEATH_EVENT Column.
                        The correlation coefficients indicate the strength and direction of the linear relationship between each feature and the target variable.
                        <br></br> <strong> "Positive values"</strong>     indicate a positive correlation (as one variable increases, the other tends to increase),
                        <br></br> <strong>"Negative values"</strong>   indicate a negative correlation (as one variable increases, the other tends to decrease),
                        and values close to zero suggest little to no linear correlation.
                        <br></br><br></br>
                        By plotting these correlation values as a bar chart, we can visually assess which features are most strongly correlated (positively or negatively) with the target variable, providing insights into which features may have a significant impact on the target variable's outcome.
                        <br></br>


                        <SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`correlations = df.drop('DEATH_EVENT', axis=1).corrwith(df['DEATH_EVENT'])
//Create DataFrame for the correlations
corr_df = pd.DataFrame({'Feature': correlations.index, 'Correlation': correlations.values})
//Creating bar plot using Plotly Express
px.bar(corr_df, x='Feature', y='Correlation', labels={'Feature': 'Feature Name', 'Correlation': 'Correlation with Target'})
`}


                        </SyntaxHighlighter>

 {/* <img src={projectimag} alt='image1' className='paten_image_1' /> */}


 <img src={corr_1} alt='image1' className='corr_1_image' /> <br>
                    </br><br>
                    </br><br>
                    </br>
 The chart clearly indicates that the variables<strong>"ejection_fraction," "serum_creatinine," "age," "serum_sodium," and "time"</strong>  have a significant impact on the target variable<strong>"DEATH_EVENT."</strong>  These variables are likely to be the most influential factors for a machine learning model when predicting the "DEATH_EVENT" outcome.
<br></br><br></br><br></br><br></br>
To gain a deeper understanding and select the most informative variables for predicting the "DEATH_EVENT," we can conduct various statistical tests such as the <strong>Chi-Square test, p-value analysis, and t-test</strong> . These tests will provide insights into which variables have the strongest associations and predictive power when it comes to "DEATH_EVENT."
<br></br><br></br><br></br>
Lets understand what each term means in simple terms and how it helps to define our hypothesis, i.e: <strong>Chi-Square test, p-value analysis, and t-test </strong> , before applyying machine learning models.
<br></br><br></br>
<strong>Chi-Square test ---> </strong>

This test is used to determine whether there is a statistically significant association (i.e., independence or dependence) between two categorical variables.<br></br> The null hypothesis (H0) assumes that the two variables are independent, while the alternative hypothesis (Ha) suggests that there is a dependency between them.<br></br>
The chi-squared test calculates a test statistic (the chi-squared statistic) based on the differences between the observed and expected frequencies.<br></br>
 If the chi-squared statistic is sufficiently large, it indicates a significant deviation from the expected frequencies, suggesting that the two variables are not independent, and the null hypothesis is rejected. On the other hand, if the chi-squared statistic is small, it suggests that there is no significant relationship between the variables, and the null hypothesis is not rejected.
 <br></br><br></br>
<strong>T-test---> </strong>A t-test is a statistical hypothesis test used to determine if there is a significant difference between the means of two groups or samples. It is commonly used to compare the means of two groups to assess whether the observed differences are statistically significant or if they could have occurred due to random chance.<br></br><br></br>
Here we would be conducting the Independent Sample test.<br></br>
In the context of a t-test, the null hypothesis typically states that there is no significant difference between the means of the two groups being compared. It assumes that any observed difference in sample means is
<br></br><br></br>
<strong>P-Value---> </strong> The p-value is used to determine whether an observed effect or result in a statistical analysis is statistically significant. In other words, it helps answer the question: "Is the observed result due to chance, or is it likely a real effect?" A low p-value suggests that the observed result is less likely to be due to chance, while a high p-value indicates that the result is more likely to be a random occurrence.
<br></br><br></br> 


I computed the Chi-Squared Statistic P-Value for each variable to ensure that we haven't overlooked any significant variables in relation to the target variable.                  
<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">

{`from sklearn.metrics import accuracy_score, confusion_matrix, classification_report

//Creating a funtion for faster computing.
def chi_squared_test(df, target_column, categorical_columns):
// Creating the contingency table
contingency_table = pd.crosstab(df[target_column], df[categorical_columns])
                      
//Performing chi-squared test and the P value 
chi2, p, dof, expected = stats.chi2_contingency(contingency_table)
                      
//Results
print("Chi-Squared Statistic:", chi2)
print("P-Value:", p)
print("Degrees of Freedom:", dof)`}       </SyntaxHighlighter>

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`chi_squared_test(df, 'DEATH_EVENT', 'anaemia') 
Output: 
        Chi-Squared Statistic: 1.042175485287005
        P-Value: 0.3073160508415107
        Degrees of Freedom: 1       `}    </SyntaxHighlighter>


<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
{`chi_squared_test(df, 'DEATH_EVENT', 'diabetes')
Output: 
        Chi-Squared Statistic: 0.0
        P-Value: 1.0
        Degrees of Freedom: 1

chi_squared_test(df, 'DEATH_EVENT', 'ejection_fraction')
Output: 
        Chi-Squared Statistic: 65.33158131636927
        P-Value: 6.459327810543188e-08
        Degrees of Freedom: 16

chi_squared_test(df, 'DEATH_EVENT', 'high_blood_pressure')
Output: 
        Chi-Squared Statistic: 1.5434607612967581
        P-Value: 0.21410341199416902
        Degrees of Freedom: 1

chi_squared_test(df, 'DEATH_EVENT', 'platelets')
Output: 
        Chi-Squared Statistic: 172.07945060207987
        P-Value: 0.5482703513757756
        Degrees of Freedom: 175

chi_squared_test(df, 'DEATH_EVENT', 'serum_creatinine')
Output: 
        Chi-Squared Statistic: 92.42848935302217
        P-Value: 3.1452364264229703e-06
        Degrees of Freedom: 39

chi_squared_test(df, 'DEATH_EVENT', 'serum_sodium')
Output: 
        Chi-Squared Statistic: 45.80089931117036
        P-Value: 0.009600557349298953
        Degrees of Freedom: 26

chi_squared_test(df, 'DEATH_EVENT', 'sex')
Output: 
        Chi-Squared Statistic: 0.0
        P-Value: 1.0
        Degrees of Freedom: 1

chi_squared_test(df, 'DEATH_EVENT', 'smoking')
Output: 
        Chi-Squared Statistic: 0.007331473567119502
        P-Value: 0.9317652998235507
        Degrees of Freedom: 1  `}    </SyntaxHighlighter>
<br></br>
<br></br>
<br></br>
Upon reviewing all the values, it becomes evident that "serum_creatinine" and "ejection_fraction" are the most promising variables for detecting heart failure.

<br></br><br></br><br></br>
<strong>Null Hypothesis (H0): </strong>
There is no significant difference in serum creatinine levels between survivors and patients who experienced a death event.
<br></br>
<strong>Alternative Hypothesis (Ha):</strong>
 There is a significant difference in serum creatinine levels between survivors and patients who experienced a death event.
<br></br><br></br><br></br>

Cross Verify it with the T-test and Mann-Whitney U test
<br></br><br></br>
<br></br><br></br>

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
{`import numpy as np
from scipy.stats import mannwhitneyu

//Creating  arrays for ejection_fraction & serum_creatinine based on the DEATH_EVENT
ejection_fraction_death = df[df['DEATH_EVENT'] == 1]['ejection_fraction']
ejection_fraction_survival = df[df['DEATH_EVENT'] == 0]['ejection_fraction']

serum_creatinine_death = df[df['DEATH_EVENT'] == 1]['serum_creatinine']
serum_creatinine_survival = df[df['DEATH_EVENT'] == 0]['serum_creatinine']

//The Mann-Whitney U test  & t test for ejection_fraction & serum_creatinine
statistic_ef, p_value_ef = mannwhitneyu(ejection_fraction_death, ejection_fraction_survival)
t_statistic_ejection_fraction, p_value_ejection_fraction = stats.ttest_ind(ejection_fraction_survival, ejection_fraction_death)



statistic_sc, p_value_sc = mannwhitneyu(serum_creatinine_death, serum_creatinine_survival)
t_statistic_serum_creatinine, p_value_serum_creatinine = stats.ttest_ind(serum_creatinine_survival, serum_creatinine_death)

//Results for ejection_fraction & serum_creatinine
print("Mann-Whitney U Statistic (ejection_fraction):", statistic_ef)
print("P-Value (ejection_fraction):", p_value_ef)
print("T-statistic:", t_statistic_ejection_fraction)
print("\n\n")
print("Mann-Whitney U Statistic (serum_creatinine):", statistic_sc)
print("P-Value (serum_creatinine):", p_value_sc)
print("T-statistic:", t_statistic_serum_creatinine)
print("\n\n\n")
//Interpret the results for ejection_fraction & serum_creatinine
alpha = 0.05  # Standard  0.005
if p_value_ef < alpha:
    print("Reject the null hypothesis for ejection_fraction: There is a significant difference in ejection fraction between the two groups.")
else:
    print("Fail to reject the null hypothesis for ejection_fraction: There is no significant difference in ejection fraction between the two groups.")
print("\n")
if p_value_sc < alpha:
    print("Reject the null hypothesis for serum_creatinine: There is a significant difference in serum creatinine levels between the two groups.")
else:
    print("Fail to reject the null hypothesis for serum_creatinine: There is no significant difference in serum creatinine levels between the two groups.")



OUTPUT: 
            Mann-Whitney U Statistic (ejection_fraction): 6311.5
            P-Value (ejection_fraction): 7.368249168477738e-07
            T-statistic: 4.805628268396391


            Mann-Whitney U Statistic (serum_creatinine): 14190.0
            P-Value (serum_creatinine): 1.5809979011834038e-10
            T-statistic: -5.306457599754317


            Reject the null hypothesis for ejection_fraction: There is a significant difference in ejection fraction between the two groups.

            Reject the null hypothesis for serum_creatinine: There is a significant difference in serum creatinine levels between the two groups.
`}    </SyntaxHighlighter>
<br></br>
As we have rejected our Null Hypothesis and we are free to use the variable ejection_fraction & serum_creatinine against the target variable  "DEATH_EVENT"
<br></br><br></br>
Thus now we apply and preict using Logistic Regression & Navies Bayes:
<h3>Applying Logistic Regression</h3>

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`from sklearn.preprocessing import StandardScaler
standard_scale = StandardScaler()
col_to_scale = [ "ejection_fraction",'serum_creatinine',"serum_sodium"]
df[col_to_scale] = standard_scale.fit_transform(df[col_to_scale])
from sklearn.model_selection import train_test_split
#X = df[["creatinine_phosphokinase","ejection_fraction","serum_creatinine","serum_sodium","high_blood_pressure"]]

X = df[["ejection_fraction","serum_creatinine"]]
y = df.DEATH_EVENT

X_train, X_test, y_train, y_test = train_test_split(X, y, test_size=0.2, random_state=2)
`}    </SyntaxHighlighter>

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`ffrom sklearn.linear_model import LogisticRegression
accuracy_list = []
lr_model = LogisticRegression(solver="liblinear")
lr_model.fit(X_train, y_train)
lr_prediction = lr_model.predict(X_test)
lr_accuracy = (round(accuracy_score(lr_prediction, y_test), 4) * 100) #percentage
accuracy_list.append(lr_accuracy)

Output: 
            [81.67 %]
`

}    </SyntaxHighlighter>


<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`from sklearn.metrics import accuracy_score, confusion_matrix, classification_report
conf_matrix = confusion_matrix(y_test, lr_prediction)
conf_matrix

Output: 
        array([[41,  2],
            [ 9,  8]]
`

}    </SyntaxHighlighter>

The confusion matrix states that:
<br></br>
<br></br>
True Positive (TP): 41<br></br>
False Negative (FN): 2<br></br>
False Positive (FP): 9<br></br>
True Negative (TN): 8<br></br>
Here's what can be said about this confusion matrix:<br></br>
<br></br><br></br>
True Positives (TP): There are 41 instances where the model correctly predicted the positive class (in a binary classification problem, this typically represents the "event" or "positive" class, which may be related to the "Death_event" ).
<br></br><br></br>
False Negatives (FN): There are 2 instances where the model incorrectly predicted the negative class when the true class was positive. In other words, these are cases where the model failed to identify actual positive instances.
<br></br><br></br>
False Positives (FP): There are 9 instances where the model incorrectly predicted the positive class when the true class was negative. These are cases where the model made a positive prediction when it should have been negative.
<br></br><br></br>
True Negatives (TN): There are 8 instances where the model correctly predicted the negative class. These are cases where the model correctly identified actual negative instances.
<br></br><br></br>

<h3>Naive Bayes </h3>

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`from sklearn.naive_bayes import GaussianNB
//Create a GaussianNB classifier
clf = GaussianNB()
//Train the classifier on the training data
clf.fit(X_train, y_train)
//Predict the labels of the test data
y_pred = clf.predict(X_test)
//Evaluate the classifier's performance
print(clf.score(X_test, y_test)*100)


`}    </SyntaxHighlighter>

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`ffrom sklearn.linear_model import LogisticRegression
nb_model = GaussianNB()
nb_model.fit(X_train, y_train)
nb_prediction = nb_model.predict(X_test)
nb_accuracy = (round(accuracy_score(nb_prediction, y_test), 4) * 100) #percentage
accuracy_list.append(nb_accuracy)

Output:
            [78.33 %]
`

}    </SyntaxHighlighter>


<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`from sklearn.metrics import accuracy_score, confusion_matrix, classification_report
conf_matrix = confusion_matrix(y_test, nb_prediction)
conf_matrix

Output: 
        array([[41,  2],
            [11,  6]],
`

}    </SyntaxHighlighter>
The confusion matrix states that:
<br></br>
<br></br>
True Positive (TP): 41<br></br>
False Negative (FN): 2<br></br>
False Positive (FP): 11<br></br>
True Negative (TN): 6<br></br>



<br></br>
<br></br>
<br></br>
Lets See the graph of "serum_creatinine" & "ejection_fraction"  , with HUE is "DEATH_event"

<SyntaxHighlighter language="jsx" style={prism} className="custom-syntax-highlighter_table">
                            {`fig = px.scatter(hp, x='serum_creatinine', y='ejection_fraction', color='DEATH_EVENT')
fig`}    </SyntaxHighlighter>
<br></br><br></br>
To further validate the predictive significance of serum creatinine and ejection fraction, we created a scatterplot where we placed serum creatinine values on the x-axis and ejection
 fraction values on the y-axis. We then color-coded each data point to represent the survival status of patients (either survived or deceased). 
 This visualization clearly illustrates a noticeable separation between patients who survived and those who did not.<br></br><br></br>
 <img src={comp} alt='image1' className='comp_image' />
 <br></br><br></br>
 In practical terms, these results suggest that Serum Creatinine and Ejection Fraction are likely important factors associated with the DEATH_EVENT variable. Specifically:
<br></br>
<br></br>For Serum Creatinine: It appears that higher Serum Creatinine levels are associated with a higher likelihood of DEATH_EVENT = 1 (death event).
<br></br>For Ejection Fraction: Higher Ejection Fraction values may be associated with DEATH_EVENT = 0 (no death event).



                    </div>
                    <br>
                    </br>
                </div>
                <br>
                </br>

                <a className='box_1'> Next Project  </a>
                    {/* # <Link to='https://viraj63.github.io/vt.github.io/' className='box_2'>Graph_Networks</Link> */}
               
                <a href='https://viraj63.github.io/vt.github.io/' className='box_2'>Graph_Networks </a>
            </div>
        </div>
    )
}

export default Project_15
